<template>
    <div id="app-search">
        <div class="top-search-bar" v-if="search_type == '/' || search_type == '/nearby' || search_type == '/search'">
            <div class="input-search">
                <input type="text" name="studycafe" v-on:keyup.enter="enterOnSearchFunc(search_type)" v-model="keyword" class="cafe-search" placeholder="#대전 유성 스터디카페"/>
            </div>
            <div class="btn-search">
                <a href="javascript:void(0);">
                    <img src="../assets/images/search.png" alt="icon-search" class="img-search" @click="searchBtn(search_type)">
                </a>
            </div>
        </div>
        <div class="top-search-bar choice-location" v-if="search_type == '/area'">
            <div class="select-search">
                <div>
                    <select name="city" id="" class="select-city city-1" @change="selArea" v-model="sel_area_value">
                        <option value="">시/도 전체</option>
                        <option :key="index" v-for="(item, index) in area_list" :value="item.area_code">{{item.area_name}}</option>
                    </select>
                </div>
                <div>
                    <select name="city" id="" class="select-city city-2" @change="selCity" v-model="sel_city_value">
                        <option value="">시/군/구 전체</option>
                        <option :key="index" v-for="(item, index) in city_list" :value="item.city_id">{{item.city_name}}</option>
                    </select>
                    <select name="city" id="" class="select-city city-3" v-model="sel_town_value">
                        <option value="">동 전체</option>
                        <option :key="index" v-for="(item, index) in town_list" :value="item.town_id">{{item.town_name}}</option>
                    </select>
                    <div class="btn-search">
                        <a href="javascript:void(0);">
                            <img src="../assets/images/search.png" alt="icon-search" class="img-search" @click="searchBtn('area')">
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="top-search-bar choice-location" v-if="search_type == '/station'">
            <div class="select-search">
                <div>
                    <select name="city" id="" class="select-city city-1" @change="selArea" v-model="sel_area_value">
                        <option value="">시/도 전체</option>
                        <option :key="index" v-for="(item, index) in area_list" :value="item.area_code" >{{item.area_name}}</option>
                    </select>
                </div>
                <div>
                    <select name="city" id="" class="select-city city-2" @change="selSubwayline" v-model="sel_subwayline_value">
                        <option value="">호선 전체</option>
                        <option :key="index" v-for="(item, index) in subwayline_list" :value="item.subwayline">{{item.subwayline_name}}</option>
                    </select>
                    <select name="city" id="" class="select-city city-3" v-model="sel_station_value">
                        <option value="">역 전체</option>
                        <option :key="index" v-for="(item, index) in station_list" :value="item.station_id">{{item.station_name}}</option>
                    </select>
                    <div class="btn-search">
                        <a href="javascript:void(0);">
                            <img src="../assets/images/search.png" alt="icon-search" class="img-search" @click="searchBtn('station')">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as config from '../js/config';
    import common from '../js/common';
    import EventBus from '../js/event_bus';
    import $ from 'jquery';

    export default {
        name: 'AppSearch',
        data(){
            return {
                search_type: '/',
                store_data: {},
                keyword: '',
                area_list: [],
                city_list: [],
                town_list: [],
                subwayline_list: [],
                station_list: [],
                sel_area_value: '',
                sel_city_value: '',
                sel_town_value: '',
                sel_subwayline_value: '',
                sel_station_value: ''
            }
        },
        mounted(){
            this.$nextTick(function(){
                EventBus.$on('search-init-data', (response) => {
                    this.initData();
                    common.setParams({});
                });

                $('html').click(function(e) {
                    if(!$(e.target).hasClass("cafe-search")) {
                        $('.cafe-search').blur();
                    }
                });

            });
        },
        methods: {
            mainSearchFunc(type){
                var data = {};
                if(this.keyword != ''){
                    var keyword = this.keyword.split(' ');
                    var data = {'keyword': keyword};
                    if(type == '/search') {
                        EventBus.$emit('search-data', data);
                    }else{
                        common.setParams(data);
                        this.$router.push('/search');
                    }
                }else{
                    $('.cafe-search').blur();
                    var data = {
                        code: this.$store.state.popup_code.TEXT,
                        res: {},
                        name: '검색어를 입력하세요.'
                    };
                    EventBus.$emit('popup-data', data);
                }
            },
            nearbySearchFunc(){
                var data = {};
                if(this.keyword != ''){
                    var keyword = this.keyword.split(' ');
                    data.keyword = keyword;
                }
                EventBus.$emit('nearby-search-data', data);
            },
            enterOnSearchFunc(type){
                if(type == '/' || type == '/search'){
                    this.mainSearchFunc(type);
                }else if(type == '/nearby'){
                    this.nearbySearchFunc();
                }
            },
            searchBtn(type){
                // 검색어 입력하여 검색
                if(type == '/' || type == '/search'){
                    this.mainSearchFunc(type);
                }

                // 내주변 화면에서의 검색
                if(type == '/nearby'){
                    this.nearbySearchFunc();
                }

                // 지역 화면에서의 검색
                if(type == 'area'){
                    var data = {};
                    data.area_code = this.sel_area_value;
                    data.city_id = this.sel_city_value;
                    data.town_id = this.sel_town_value;
                    EventBus.$emit('area-search-data', data);
                }

                if(type == 'station'){
                    if(this.sel_station_value != ''){
                        var data = {};
                        data.area_code = this.sel_area_value;
                        data.subwayline = this.sel_subwayline_value;
                        data.station_id = this.sel_station_value;
                        EventBus.$emit('station-search-data', data);
                    }else{ // 코드 추가 - 2020-12-21
                        var data = {
                                code: 103,
                                message: '역을 선택해주세요.'
                        };
                        EventBus.$emit('popup-data', data);
                    }
                }
            },
            selArea(e){
                if(this.search_type == '/area'){
                    this.city_list = [];
                    this.town_list = [];
                    if(this.sel_area_value != ''){
                        common.getData(config.REQ_CITY_LIST, {'area_code': this.sel_area_value}, (response) => {
                            this.city_list = response;
                        })
                        // 코드 추가 - 2020-12-21
                        this.sel_city_value = '';
                        this.sel_town_value = '';
                    }else{
                        this.sel_area_value = '';
                        this.sel_city_value = '';
                        this.sel_town_value = '';
                    }
                }else if(this.search_type == '/station'){
                    this.subwayline_list = [];
                    this.station_list = [];
                    if(this.sel_area_value != ''){
                        common.getData(config.REQ_SUBWAYLINE_LIST, {'area_code': this.sel_area_value}, (response) => {
                            this.subwayline_list = response;
                        })
                        // 코드 추가 - 2020-12-21
                        this.sel_subwayline_value = '';
                        this.sel_station_value = '';
                    }else{
                        this.sel_area_value = '';
                        this.sel_subwayline_value = '';
                        this.sel_station_value = '';
                    }
                }

            },
            selCity(e){
                this.town_list = [];
                if(this.sel_city_value != ''){
                    common.getData(config.REQ_TOWN_LIST, {'city_id': this.sel_city_value}, (response) => {
                        this.town_list = response;
                    })
                    // 코드 추가 - 2020-12-21
                    this.sel_town_value = '';
                }else{
                    this.sel_city_value = '';
                    this.sel_town_value = '';
                }
            },
            selTown(e){
                // this.sel_town_value = e.target.value;
            },
            selSubwayline(e){
                this.station_list = [];
                if(this.sel_subwayline_value != ''){
                    common.getData(config.REQ_STATION_LIST, {'area_code': this.sel_area_value, 'subwayline': this.sel_subwayline_value}, (response) => {
                        this.station_list = response;
                    })
                    // 코드 추가 - 2020-12-21
                    this.sel_station_value = '';
                }else{
                    this.sel_subwayline_value = '';
                    this.sel_station_value = '';
                }
            },
            setArea(){
                if(this.search_type == '/area'){
                    common.getData(config.REQ_AREA_LIST, {type:'city'}, (response) => {
                        this.area_list = response;
                    })
                } else if(this.search_type == '/station') {
                  common.getData(config.REQ_AREA_LIST, {type:'station'}, (response) => {
                    this.area_list = response;
                  })
                }
            },
            initData(){
                this.keyword = '';
                this.area_list = [];
                this.city_list = [];
                this.town_list = [];
                this.subwayline_list = [];
                this.station_list = [];
                this.sel_area_value = '';
                this.sel_city_value = '';
                this.sel_town_value = '';
                this.sel_subwayline_value = '';
                this.sel_station_value = '';
            },
        },
        destroyed(){
            EventBus.$off('search-data-init');
            EventBus.$off('nearby-search-data');
        },
        computed: {
            getCurrentPage() {
                return this.$store.getters.getCurrentPage.value;
            },
            getParams(){
                return this.$store.getters.getParams.value;
            },
        },
        watch:{
            getCurrentPage(){
                this.search_type = this.$store.getters['getCurrentPage'].value;
                this.setArea();
            },
            keyword(){
                if(this.hasFocus()){
                    console.log(this.hasFocus())
                }
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppSearch.vue